'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import { AssetIcon } from '@/blocks/components/AssetIcon';
import { AssetsCarousel } from '@/blocks/components/AssetsCarousel';
import { Container } from '@/blocks/components/Container';
import { CurrencyBadge } from '@/blocks/components/CurrencyBadge';
import { CenterHeading, Section, VStack } from '@/blocks/components/layout';
import { FormatAssetName } from '@/blocks/formatters';
import { extractAssetName } from '@/blocks/formatters/format-asset-name';
import typography from '@/styles/typography.module.scss';

import { getAllAssets } from '@/app/[lang]/price-chart/[category]/data';
import { getAssetPageLink } from '@/app/[lang]/price-chart/[category]/navigation-utils';
import { Asset as LocalAsset } from '@/app/[lang]/price-chart/[category]/types';

import styles from './styles.module.scss';

export function CoinPageCategoryPopularAssetsSection({ asset }: { asset: LocalAsset }) {
  const otherAssets = getAllAssets().filter((a) => a.category === asset.category);
  const tr = useTranslations('pages.priceCharts.asset.sections.assetsCarousel');

  const heading = {
    forex: tr.rich('forex.title'),
    crypto: tr.rich('crypto.title'),
    index: tr.rich('index.title'),
    stocks: tr.rich('stocks.title'),
    commodity: tr.rich('commodity.title'),
  }[asset.category];

  const row1 = otherAssets.slice(0, otherAssets.length / 2);
  const row2 = otherAssets.slice(otherAssets.length / 2);

  function renderAsset(item: LocalAsset) {
    return (
      <CurrencyBadge
        data-event-label={extractAssetName(item)}
        href={getAssetPageLink(item.name)}
        text={<FormatAssetName assetName={extractAssetName(item)} />}
        icon={<AssetIcon assetName={item.name} />}
      />
    );
  }

  return (
    <Section>
      <Container className={styles.container}>
        <VStack>
          <CenterHeading>
            <h2 className={typography.h2}>{heading}</h2>
          </CenterHeading>
          <AssetsCarousel>
            <AssetsCarousel.Row<LocalAsset> items={row1} renderItem={renderAsset} />
            <AssetsCarousel.Row<LocalAsset> items={row2} renderItem={renderAsset} dir={'left'} />
          </AssetsCarousel>
        </VStack>
      </Container>
    </Section>
  );
}
